import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ArrowNW.svg",
  "use": "ArrowNW.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ArrowNW.svg\"><path d=\"M47.4077,47.4387a1.98,1.98,0,0,1-2.8079.0058L20,22.8449V39a2,2,0,0,1-4,0V18a2,2,0,0,1,2-2H39a2,2,0,1,1,0,4H22.7821l24.62,24.6193A1.999,1.999,0,0,1,47.4077,47.4387Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol